import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, createFieldsGroups, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

const sharedItems: Map<string, ConfirmationData> = new Map([
    ["e7e244b4-1625-40ca-b892-f937ab7b4c32", {}],
    ["7613cb0b-05cd-4bf6-b24f-953cf590043b", {}],
    ["47a36cb9-8d3d-4c88-aedb-e5bf4e297655", {}],
    ["cb4d9886-2b40-4f27-8d90-f01d759bd510", {}],
    ["20f8c1d3-0e72-4b5b-9656-77f60965f1f9", { showBorder: true }],
]);

const defaultItems: Map<string, ConfirmationData> = new Map([
    ["49404bd2-15a2-4706-89ff-2a4ffb85605d", { fontWeight: "bold", }],
]);

const defaultJournalistItems: Map<string, ConfirmationData> = new Map([
    ["a429122b-db2c-4419-9b62-6ee946d8ec52", { fontWeight: "bold", }],
]);

const defaultStateOfficialItems: Map<string, ConfirmationData> = new Map([
    ["395f109d-5a72-4639-a4f6-9e7582ff35a4", { fontWeight: "bold", }],
]);

const defaultMilitaryItems: Map<string, ConfirmationData> = new Map([
    ["6346f3ed-829a-41fc-bba9-916a5cb4fca2", { fontWeight: "bold", }],
]);

const defaultBodyguardItems: Map<string, ConfirmationData> = new Map([
    ["9e00b6c9-2629-4597-9a37-5a4de740ee2b", { fontWeight: "bold", }],
]);

const defaultMiningItems: Map<string, ConfirmationData> = new Map([
    ["b326ecb8-806f-431e-aecd-51a3f0aaa859", { fontWeight: "bold", }],
]);

const defaultForexItems: Map<string, ConfirmationData> = new Map([
    ["a7012f58-b0d7-42e4-adbb-709748ab656a", { fontWeight: "bold", }],
]);

const defaultMissionaryItems: Map<string, ConfirmationData> = new Map([
    ["c8dcfd02-f7ab-487f-bd04-0fd6b41efd02", { fontWeight: "bold", }],
]);

const defaultArmsItems: Map<string, ConfirmationData> = new Map([
    ["404e2301-e521-4fda-9e0e-b6232637d409", { fontWeight: "bold", }],
    ["404e2301-e521-4fda-9e0e-b6232637d409|e7e244b4-1625-40ca-b892-f937ab7b4c32", {}],
    ["404e2301-e521-4fda-9e0e-b6232637d409|24e83e5a-3446-43bf-a5ea-a9bbac598440", { showBorder: true }],
]);

const defaultIllegalItems: Map<string, ConfirmationData> = new Map([
    ["ecad4fd4-a0b1-40b2-9202-c536f198de4d", { fontWeight: "bold", }],
    ["ecad4fd4-a0b1-40b2-9202-c536f198de4d|e7e244b4-1625-40ca-b892-f937ab7b4c32", {}],
    ["ecad4fd4-a0b1-40b2-9202-c536f198de4d|24e83e5a-3446-43bf-a5ea-a9bbac598440", { showBorder: true }],
]);

export const defaultPoliticallyExposedPersonInformation: Map<string, ConfirmationData> = new Map([
    ["fef020cd-5671-482b-a815-5d3fb299223d", { fontWeight: "bold", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt1", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt2", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt3", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt4", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt5", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt6", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt7", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt8", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt9", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt10", { type: "checkbox", }],
    ["e1b20b24-9aeb-49cd-9288-adb444a17f71-opt11", { type: "checkbox", showBorder: true }],
]);

export const updatePoliticallyExposedPersonInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const section = page.sections.find(section => section.section_id === "57cfd399-2f41-4e35-97ba-b9c6d78d7573");
    if (!section) {
        return cd;
    }
    const groups = section.groups.filter(group => group.group_id === "49404bd2-15a2-4706-89ff-2a4ffb85605d" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedItems = createFieldsGroups(groups, sharedItems);

    const journalistGroups = section.groups.filter(group => group.group_id === "a429122b-db2c-4419-9b62-6ee946d8ec52" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedJournalistItems = createFieldsGroups(journalistGroups, sharedItems);

    const stateOfficialGroups = section.groups.filter(group => group.group_id === "395f109d-5a72-4639-a4f6-9e7582ff35a4" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedStateOfficialItems = createFieldsGroups(stateOfficialGroups, sharedItems);

    const militaryGroups = section.groups.filter(group => group.group_id === "6346f3ed-829a-41fc-bba9-916a5cb4fca2" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedMilitaryItems = createFieldsGroups(militaryGroups, sharedItems);

    const bodyguardGroups = section.groups.filter(group => group.group_id === "9e00b6c9-2629-4597-9a37-5a4de740ee2b" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedBodyguardItems = createFieldsGroups(bodyguardGroups, sharedItems);

    const miningGroups = section.groups.filter(group => group.group_id === "b326ecb8-806f-431e-aecd-51a3f0aaa859" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedMiningItems = createFieldsGroups(miningGroups, sharedItems);

    const forexGroups = section.groups.filter(group => group.group_id === "a7012f58-b0d7-42e4-adbb-709748ab656a" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedForexItems = createFieldsGroups(forexGroups, sharedItems);

    const missionaryGroups = section.groups.filter(group => group.group_id === "c8dcfd02-f7ab-487f-bd04-0fd6b41efd02" && group.fields[0].value !== "").sort((a, b) => a.order - b.order);
    const updatedMissionaryItems = createFieldsGroups(missionaryGroups, sharedItems);

    const answersMap = createQuestionValueMap(page);

    // Array de IDs de todos los grupos a verificar
    const groupIds = [
        "49404bd2-15a2-4706-89ff-2a4ffb85605d", // Miembro de la legislatura
        "a429122b-db2c-4419-9b62-6ee946d8ec52", // Periodista
        "395f109d-5a72-4639-a4f6-9e7582ff35a4", // Funcionarios estatales
        "6346f3ed-829a-41fc-bba9-916a5cb4fca2", // Personal militar
        "9e00b6c9-2629-4597-9a37-5a4de740ee2b", // Guardaespaldas
        "b326ecb8-806f-431e-aecd-51a3f0aaa859", // Minería, petróleo y gas
        "a7012f58-b0d7-42e4-adbb-709748ab656a", // Agente de divisas
        "c8dcfd02-f7ab-487f-bd04-0fd6b41efd02", // Misionero
        "404e2301-e521-4fda-9e0e-b6232637d409", // Vendedor de armas
        "ecad4fd4-a0b1-40b2-9202-c536f198de4d"  // Actividad ilegal
    ];

    // Para cada grupo, verificar si tiene "Actualmente en este puesto" con valor "Sí"
    for (const groupId of groupIds) {
        const currentPositionKey = `${groupId}|28525af1-d28f-455d-9a16-1aff4a10ae40`;
        const endDateKey = `${groupId}|20f8c1d3-0e72-4b5b-9656-77f60965f1f9`;

        // Si el valor es "Sí", cambiar la fecha de fin a "actualmente"
        if (answersMap.get(currentPositionKey)?.value === "Sí") {
            const isHidden = answersMap.get(endDateKey)?.hidden || false;
            answersMap.set(endDateKey, { value: "actualmente", hidden: isHidden, label: answersMap.get(endDateKey)?.label });
        }
    }

    const tupleArray = mapToTupleArray(answersMap);
    return updateMapWithFields(tupleArray, new Map([
        ...cd,
        ...defaultItems,
        ...updatedItems,
        ...defaultJournalistItems,
        ...updatedJournalistItems,
        ...defaultStateOfficialItems,
        ...updatedStateOfficialItems,
        ...defaultMilitaryItems,
        ...updatedMilitaryItems,
        ...defaultBodyguardItems,
        ...updatedBodyguardItems,
        ...defaultMiningItems,
        ...updatedMiningItems,
        ...defaultForexItems,
        ...updatedForexItems,
        ...defaultMissionaryItems,
        ...updatedMissionaryItems,
        ...defaultArmsItems,
        ...defaultIllegalItems,
    ]));
}
